import { Pipe, PipeTransform } from "@angular/core";


@Pipe({name: 'formatPhoneNumber'})
export class FormatPhoneNumberPipe implements PipeTransform {
  transform(value: string): any {
      let result = value !== null ? (value).replace(/^(\d{1,2})(\d{0,5})(\d{0,4})$/, "($1) $2-$3") : value;
      return result;      
  }
}